import type { SupportContent } from "./types";

export const supportZh: SupportContent = {
  seo: {
    title: "支持 - Luxoria",
    description: "获取 Luxoria 在 HDR 转换、保存与导出结果方面的帮助。"
  },
  tag: "支持",
  title: "Luxoria 支持",
  subtitle:
    "如果你在 HDR 转换、保存或查看导出结果时遇到问题，可以通过邮件联系我们，并尽量附上以下信息。",
  contactLabel: "邮箱",
  contactNote: "我们会阅读每一条消息。请尽量附上下列信息，以便我们更快地帮助你。",
  issueTitle: "反馈问题时，请尽量提供",
  issueItems: [
    "设备型号",
    "系统版本",
    "Luxoria 版本",
    "素材类型：照片、批量照片或视频",
    "你正在进行的操作",
    "实际遇到的问题"
  ],
  faqTitle: "常见问题",
  faqGroups: [
    {
      title: "了解 Luxoria",
      items: [
        {
          question: "Luxoria 是什么？",
          answer: "Luxoria 是一款照片与视频 HDR 转换应用，帮助你将 SDR 素材转换为适合 HDR 显示的输出。"
        },
        {
          question: "支持哪些素材？",
          answer: "支持单张照片、批量照片，以及视频。视频可导出 HEVC Main10 HLG 输出。"
        },
        {
          question: "会修改我的原始文件吗？",
          answer: "不会。Luxoria 生成转换后的输出文件，不会改动你选择的原始素材。"
        }
      ]
    },
    {
      title: "转换与导出排查",
      items: [
        {
          question: "为什么视频转换需要时间？",
          answer: "视频 HDR 转换需要逐帧处理和导出，较长或分辨率较高的视频会花费更多时间。"
        },
        {
          question: "为什么 HDR 在不同屏幕或应用里看起来不同？",
          answer:
            "HDR 显示效果取决于屏幕、操作系统、查看应用以及设备是否支持 HDR 播放，因此同一文件在不同环境中可能呈现不同效果。"
        },
        {
          question: "导出的文件保存在哪里？",
          answer: "根据平台和你的选择，输出文件可以保存到照片、文件或指定文件夹。"
        }
      ]
    }
  ],
  links: [
    { label: "隐私政策", kind: "privacy" },
    { label: "用户协议", kind: "terms" },
    { label: "返回 Luxoria", kind: "landing" }
  ]
};
